import { LeftColumn, RightColumn } from 'components/page/BaseLandingPage';
import styled from 'styled-components';

// Location-specific column overrides
export const LocationLeftColumn = styled(LeftColumn)`
    & > *:first-child {
        /* Default for 1080p - fixed heights */
        height: 56.8rem;
        flex: 0 0 auto;
        overflow-y: auto;
    }

    & > *:nth-child(2) {
        /* Offline hardware widget always has fixed height */
        height: 13.3rem;
        flex: 0 0 auto;
    }

    /* Allow flexible heights when we have enough vertical space */
    @media (min-height: 1440px) {
        & > *:first-child {
            height: auto;
            flex: 1 1 0;
        }
    }
`;

export const LocationRightColumn = styled(RightColumn)`
    & > * {
        /* Default for 1080p - fixed heights */
        height: 75.7rem;
        flex: 0 0 auto;
        overflow-y: auto;
    }

    /* Allow flexible heights when we have enough vertical space */
    @media (min-height: 1440px) {
        & > * {
            height: auto;
            flex: 1 1 0;
        }
    }
`;
